import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';

const InstancesContext = createContext();

export const useInstances = () => {
  const context = useContext(InstancesContext);
  if (!context) {
    throw new Error('useInstances deve ser usado dentro de InstancesProvider');
  }
  return context;
};

export const InstancesProvider = ({ children }) => {
  const [instances, setInstances] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  const loadInstances = async () => {
    if (!user?.cliente_id) return;
    
    try {
      setLoading(true);
      const response = await api.get('/instancias-whatsapp', {
        params: { cliente_id: user.cliente_id }
      });
      // Só array entra no estado: se a API devolver HTML (proxy errado) ou objeto de erro, `instances.some`
      // derrubava o app inteiro em tela branca — visto no print piloto de 13/09.
      setInstances(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Erro ao carregar instâncias:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadInstances();
  }, [user?.cliente_id]);

  const hasZApiInstance = instances.some(i => i.provider === 'z-api');
  const hasMetaInstance = instances.some(i => i.provider === 'meta-api');
  const hasInstagramInstance = instances.some(i => i.platform === 'instagram');

  const value = {
    instances,
    loading,
    hasZApiInstance,
    hasMetaInstance,
    hasInstagramInstance,
    refreshInstances: loadInstances
  };

  return (
    <InstancesContext.Provider value={value}>
      {children}
    </InstancesContext.Provider>
  );
};
